import bottomSheetAOL from './AOL/bottomSheet.json';
import feedbackFormAOL from './AOL/feedbackForm.json';
import globalsAOL from './AOL/globals.json';
import articlesMessageAOL from './AOL/message-types/articlesMessage.json';
import ratingDetailedAOL from './AOL/ratingDetailed.json';

const resources = {
	AOL: {
		articlesMessage: articlesMessageAOL,
		feedbackForm: feedbackFormAOL,
		ratingDetailed: ratingDetailedAOL,
		bottomSheet: bottomSheetAOL,
		globals: globalsAOL,
	},
};

export default resources;
